<template>
  <header id="inicio">
    <div class="top-container">
      <div class="center-container">
        <div class="logo-container">
          <img src="../assets/img/logo.png" alt="Pousada Recanto da Família">
        </div>
        <div class="info-container">
            <address>
              <ul class="address">
                <li><i class="fab fa-whatsapp"></i> <a href="https://wa.me/5511974750184?text=Ol%C3%A1%2C%20estou%20entrando%20em%20contato%20pelo%20site%20da%20Pousada" target="_blank" alt="11 97475-0184">(11) 97475-0184</a></li>
                <li class="separator"><span></span></li>
                <li><i class="fas fa-map-marker-alt"></i> <a alt="Rod. João Hermenegildo de Oliveira, Km 8,5" href="https://www.google.com/maps/dir/?api=1&destination=Pousada+Recanto+da+Fam%C3%ADlia+-+Guaripocaba,+Bragan%C3%A7a+Paulista+-+SP" target="_blank">Rod. João Hermenegildo de Oliveira, Km 8,5</a></li>
                <li><a alt="Bragança Paulista - SP" href="https://www.google.com/maps/dir/?api=1&destination=Pousada+Recanto+da+Fam%C3%ADlia+-+Guaripocaba,+Bragan%C3%A7a+Paulista+-+SP" target="_blank">Bragança Paulista - SP</a></li>
                <li class="separator"><span></span></li>
                <li class="email-address"><i class="far fa-envelope"></i> con&#116;a&#116;o&#64;pousadar&#101;c&#97;n&#116;o&#100;&#97;fami&#108;i&#97;&#46;&#99;om&#46;br</li>
              </ul>
            </address>

            <nav>
              <div id="navbar" class="mobile-menu-header"><img src="../assets/img/logo_menu.png" alt="Pousada Recanto da Família"> <button @click="toggleMenu">Menu</button></div>
              <ul class="top-menu" id="top-menu">
                <li class="menu-item"><anchor-router-link :scrollOptions="linkOptions" :to="{name: 'home', hash: '#inicio'}">Início</anchor-router-link></li>
                <li class="menu-item"><anchor-router-link :scrollOptions="linkOptions" :to="{name: 'home', hash: '#sobre'}">Quem somos</anchor-router-link></li>
                <li class="menu-item"><anchor-router-link :scrollOptions="linkOptions" :to="{name: 'home', hash: '#acomodacoes'}">Acomodações</anchor-router-link></li>
                <li class="menu-item"><anchor-router-link :scrollOptions="linkOptions" :to="{name: 'home', hash: '#fotos'}">Fotos</anchor-router-link></li>
                <li class="menu-item"><anchor-router-link :scrollOptions="linkOptions" :to="{name: 'home', hash: '#contato'}">Contato</anchor-router-link></li>
              </ul>
            </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import AnchorRouterLink from 'vue-anchor-router-link'

export default {
  name: 'MainHeader',
  components: {
    AnchorRouterLink
  },
  data () {
    return {
      linkOptions: {
        container: 'body',
        duration: 700,
        easing: 'ease',
        offset: 0,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true
      }
    }
  },
  methods: {
    scrollMenu: function () {
      var prevScrollpos = window.pageYOffset
      window.onscroll = function () {
        document.getElementById('top-menu').classList.remove('opened')

        var currentScrollPos = window.pageYOffset
        if (prevScrollpos > currentScrollPos && currentScrollPos > 750) {
          document.getElementById('navbar').style.top = '0'
        } else {
          document.getElementById('navbar').style.top = '-105px'
        }
        prevScrollpos = currentScrollPos
      }
    },
    toggleMenu: function () {
      let menu = document.getElementsByClassName('opened')
      if (menu.length > 0) {
        document.getElementById('top-menu').classList.remove('opened')
      } else {
        document.getElementById('top-menu').classList.add('opened')
      }
    }
  },
  created () {
    this.scrollMenu()
  }
}
</script>
